import { createFileRoute } from "@tanstack/react-router";
import {
  Download,
  FlaskConical,
  ClipboardCheck,
  GitBranch,
  Database,
  SprayCan,
} from "lucide-react";
import { SecondaryNav } from "@client/components/secondary-nav";
import { useNavPermissions } from "@client/hooks/use-nav-permissions";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/_app/data-center")({
  component: DataCenterLayout,
});

const dataCenterItems = [
  {
    titleKey: "nav.templates",
    to: "/data-center/tmpl" as const,
    icon: GitBranch,
    permission: "datacenter-tmpl",
  },
  {
    titleKey: "nav.extraction",
    to: "/data-center/extraction" as const,
    icon: FlaskConical,
    permission: "datacenter-extraction",
  },
  {
    titleKey: "nav.review",
    to: "/data-center/review" as const,
    icon: ClipboardCheck,
    permission: "datacenter-review",
  },
  { titleKey: "nav.exports", to: "/data-center/exports" as const, icon: Download, permission: "datacenter-export" },
  { titleKey: "nav.dataSources", to: "/data-center/datasources" as const, icon: Database, permission: "datacenter-datasource" },
  { titleKey: "nav.cleaning", to: "/data-center/cleaning" as const, icon: SprayCan, permission: "datacenter-cleaning" },
];

function DataCenterLayout() {
  const { t } = useTranslation("dataCenter");
  const permSet = useNavPermissions();

  const items = dataCenterItems.filter((item) => {
    if (!item.permission) return true;
    return permSet.has(item.permission);
  });

  return <SecondaryNav title={t("title")} items={items.map((item) => ({ ...item, title: t(item.titleKey) }))} />;
}
